<template>
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Right navbar links -->
    <ul class="navbar-nav align-items-center">
      <li class="nav-item mr-auto d-none d-sm-block">
        <a class="nav-link btn-pushmenu" data-widget="pushmenu" href="#" role="button"
          ><i class="icon-left"></i
        ></a>
      </li>
      <a href="javascript:void(0);" class="d-block d-sm-none mr-auto">
        <!-- <img :src="getImage('logo.svg')" alt="Dotlines" style="height: 25px" /> -->
        <img :src="getImage('logo-mini.svg')" alt="Dotlines" style="height: 24px" />
      </a>
      <!-- Messages Dropdown Menu -->
      <li class="nav-item dropdown notify-menu" v-if="show_notification == true">
        <a
          class="nav-link"
          data-toggle="dropdown"
          href="javascript:void(0)"
          @click="updateStatus()"
        >
          <i class="fas fa-bell"></i>
          <span class="badge badge-danger navbar-badge" v-if="notification_count !== 0">{{
            notification_count
          }}</span>
        </a>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <div class="notification-inner-content">
            <div v-for="message in messages">
              <router-link
                :to="message.link"
                class="dropdown-item"
                v-if="!isExternalLink(message.link)"
              >
                <!-- Message Start -->
                <div class="media">
                  <!--              <img src="/assets/images/user-avatar.jpg" alt="User Avatar" class="img-size-50 mr-3 img-circle">-->
                  <div class="media-body">
                    <h3 class="dropdown-item-title">
                      {{ message.title }}
                    </h3>
                    <p class="text-sm">{{ message.description }}</p>
                    <p class="text-sm text-muted">
                      <i class="far fa-clock mr-1"></i>
                      {{ message.time_diffrence }}
                    </p>
                  </div>
                </div>
                <!-- Message End -->
              </router-link>
              <!--              <a :href="message.link" class="dropdown-item" v-else target="_blank">-->
              <a :href="message.link" class="dropdown-item">
                <!-- Message Start -->
                <div class="media">
                  <!--              <img src="/assets/images/user-avatar.jpg" alt="User Avatar" class="img-size-50 mr-3 img-circle">-->
                  <div class="media-body">
                    <h3 class="dropdown-item-title">
                      {{ message.title }}
                    </h3>
                    <p class="text-sm">{{ message.description }}</p>
                    <p class="text-sm text-muted">
                      <i class="far fa-clock mr-1"></i>
                      {{ message.time_diffrence }}
                    </p>
                  </div>
                </div>
                <!-- Message End -->
              </a>
            </div>
            <!--          <a href="#" class="dropdown-item">
                        &lt;!&ndash; Message Start &ndash;&gt;
                        <div class="media">
            &lt;!&ndash;              <img src="/assets/images/user-avatar.jpg" alt="User Avatar" class="img-size-50 mr-3 img-circle">&ndash;&gt;
                          <div class="media-body">
                            <h3 class="dropdown-item-title">
                              Brad Diesel
            &lt;!&ndash;                  <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>&ndash;&gt;
                            </h3>
                            <p class="text-sm">Call me whenever you can...</p>
                            <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
                          </div>
                        </div>
                        &lt;!&ndash; Message End &ndash;&gt;
                      </a>-->
          </div>
          <router-link
            :to="{ name: 'AuthNotifications' }"
            class="dropdown-item dropdown-footer"
          >
            See All Messages
          </router-link>
          <!--          <a href="#" class="dropdown-item dropdown-footer">See All Messages</a>-->
        </div>
      </li>
      <li class="nav-item dropdown d-none">
        <a
          class="d-flex align-items-center nav-link dropdown-toggle"
          href="javascript:void(0)"
          role="button"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <div v-if="select_language == 'en'">
            <img :src="getImage('us.jpg')" alt="user-image" class="mr-1" height="12" />
            <span class="text-height-1">English</span>
          </div>
          <div v-if="select_language == 'bn'">
            <img :src="getImage('bd.jpg')" alt="user-image" class="mr-1" height="12" />
            <span class="text-height-1">Bangla</span>
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-animated px-1">
          <a class="dropdown-item" href="javascript:void(0)" @click="changeLang('en')">
            <img :src="getImage('us.jpg')" alt="user-image" class="mr-1" height="12" />
            <span class="text-height-1">English</span>
          </a>
          <a class="dropdown-item" href="javascript:void(0)" @click="changeLang('bn')">
            <img :src="getImage('bd.jpg')" alt="user-image" class="mr-1" height="12" />
            <span class="text-height-1">Bangla</span>
          </a>
        </div>
      </li>

      <!-- <li class="nav-item dropdown">
        <el-select
          placeholder="Select language"
          v-model="select_language"
          @change="changeLang"
        >
          <el-option
            v-for="item in [
              { value: 'en', label: 'English' },
              { value: 'bn', label: 'Bangla' }
            ]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </li> -->
      <li class="nav-item dropdown select-device">
        <el-select
          placeholder="Select Device"
          v-model="select_router"
          @change="handleRouterChange"
          filterable
        >
          <el-option
            v-for="item in this.fetchedData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </li>

      <li class="nav-item dropdown user user-menu ml-0 ml-md-3">
        <!-- Menu Toggle Button -->
        <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
          <!-- The user image in the navbar-->
          <img
            v-bind:src="profile.avatar"
            class="img-circle user-image d-none d-sm-inline-flex border"
            alt="User Image"
          />
          <!-- hidden-xs hides the username on small devices so only the image appears. -->
          <span style="text-transform: !important">{{ user_detail.name }} </span
          ><i class="icon-down"></i>
        </a>
        <ul class="dropdown-menu dropdown-menu-animated">
          <!-- The user image in the menu -->
          <li class="user-header">
            <img
              v-bind:src="profile.avatar"
              class="img-circle img-size-50"
              alt="User Image"
            />
            <p class="mb-0">
              <span class="pc fw-500 text-capitalize">{{ profile.name }}</span>
              <!-- <small>Member since {{ profile.created_at }}</small> -->
            </p>
          </li>
          <li class="user-footer d-flex justify-content-between">
            <div>
              <!--                                <a href="#" class="btn">Setting</a>-->
              <router-link :to="{ name: 'AuthProfile' }" class="btn">
                <i class="icon-settings"></i> {{ $t("setting") }}
              </router-link>
            </div>
            <div>
              <a href="javascript:void(0)" @click="logout()" class="btn btn-danger"
                ><i class="icon-log-out"></i> {{ $t("logout") }}</a
              >
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import LocalStorage from "@/services/localStorage";
import { CommonAPI } from "@/services/api";
import axios from "axios";
import mqtt from "mqtt";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    //
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  data: () => ({
    // let subscriptionID = 'user-' + '".Admin::user()->id."';
    // let clientID = 'user-' + '".Admin::user()->id."' + '_' + makeid(6);
    menuItems: [],
    connection: {
      host: "",
      port: "",
      endpoint: "/mqtt",
      clean: true,
      connectTimeout: 4000,
      reconnectPeriod: 4000,
      clientId: "",
      username: "",
      password: "",
      user: { username: "", password: "", accountId: "" },
    },
    subscription: {
      topic: "",
      qos: 0,
    },
    subscribeSuccess: false,
    // received_messages: '',
    messages: [],
    notification_count: 0,
    user_detail: {},
    show_notification: false,
    select_language: localStorage.getItem("app_lang") || "en",
    fetchedData: [],
    select_router: "",
  }),
  watch: {
    profile: function (newUser, oldUser) {
      if (!_.isEmpty(newUser)) {
        this.user_detail = newUser;
      }
    },
  },
  mounted() {
    this.initialize();
    this.fetchData();

    // this.FETCH_PROFILE();

    // this.$store.dispatch(FETCH_AUTH);
    // await this.getAuthDetail();
    // await this.getMenuItems();
    /* let SELECTOR_DATA_WIDGET = '[data-widget="treeview"]';
    let SELECTOR_LINK = '.nav-link';
    let Default = {
      trigger: SELECTOR_DATA_WIDGET + " " + SELECTOR_LINK,
      animationSpeed: 300,
      accordion: true,
      expandSidebar: false,
      sidebarButtonSelector: '[data-widget="pushmenu"]'
    } */
    /* $('[data-widget="treeview"]').each(function() {
      AdminLte.Treeview._jQueryInterface.call($(this), 'init');
    }); */
    // window.$('ul[data-widget="treeview"]').Treeview('init');

    /* const $ = window.$;
    $('[data-widget="treeview"]').each(function() {
      AdminLte.Treeview('init');
    }); */
    /* const $ = window.$;
    const trees = $('[data-widget="treeview"]');
    trees.Treeview('init'); */

    // jQuery('[data-widget="treeview"]').Treeview('init');
    // console.log(jQuery);
    // jQuery('.sidebar-toggle-btn').pushMenu(options)
  },
  methods: {
    ...mapActions(["FETCH_PROFILE", "LOGOUT", "LOGIN_AUDRA_DEVICE_SELECTION"]),
    async logout() {
      try {
        await this.LOGOUT();
        localStorage.setItem("authenticate", false);
        localStorage.removeItem("token");
        this.$router.push({ name: "Login" });
      } catch (error) {
        console.error("Error during logout:", error);
      }
    },
    async initialize() {
      // this.is_loading = true;

      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // eslint-disable-next-line eqeqeq
      if (this.APP_ENABLE_NOTIFICATION == "true") {
        this.show_notification = true;
        this.connection = {
          host: this.APP_MQTT_SERVER,
          port: this.APP_MQTT_CLIENT_PORT,
          endpoint: "/mqtt",
          clean: true,
          connectTimeout: 4000,
          reconnectPeriod: 4000,
          clientId: "",
          username: this.APP_MQTT_USERNAME,
          password: this.APP_MQTT_PASSWORD,
        };

        await this.getNotifications()
          .then((response) => {
            this.messages = response.data;

            const date_object = new Date();
            const current = date_object.getTime();
            let message_time;
            let times_ago;
            // received_object.time_diffrence = times_ago
            // this.messages.unshift(received_object)
            // this.notification_count = this.notification_count + 1

            this.messages.forEach((value, key) => {
              message_time = Date.parse(value.created_at);
              times_ago = this.timeDifference(current, message_time);
              this.messages[key].time_diffrence = times_ago;
              var url = new URL(value.link);
              // // console.log(url.pathname)
              // if (this.isMobile()){
              this.messages[key].link = url.pathname;
              // }

              // eslint-disable-next-line eqeqeq
              if (value.is_seen == 0) {
                this.notification_count = this.notification_count + 1;
              }
            });
          })
          .catch((error) => {
            // eslint-disable-next-line no-undef
            if (!_.isEmpty(error.response) && error.response.status === 403) {
              this.has_permission = false;
            }
          });

        this.createConnection();
      }
      // this.is_loading = false;
    },
    updateStatus: function () {
      const ids = [];
      this.messages.forEach((value, key) => {
        ids.push(value.id);
      });
      // console.log(this.messages);
      // console.log('ids::', ids);
      axios({
        method: "PUT",
        url: "/auth/notifications/statusUpdate",
        data: { ids: ids },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {})
        .catch((errors) => {
          // eslint-disable-next-line no-undef
          if (!_.isEmpty(errors.response) && errors.response.status === 500) {
            this.$toaster.error(errors.response.data.message);
          }
        })
        .finally(() => {
          this.notification_count = 0;
          this.getNotifications();
        });
    },
    getNotifications: function () {
      return new Promise((resolve, reject) => {
        // let params = {page: this.list.current_page}
        // params = {...this.filter, ...params};
        axios
          .get("/auth/notifications?limit=10")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    createConnection() {
      const { host, port, endpoint, ...options } = this.connection;
      let protocol = "ws";
      // eslint-disable-next-line eqeqeq
      if (parseInt(this.APP_MQTT_HTTPS_ENABLE) == 1) {
        protocol = "wss"; // `wss://${host}:${port}${endpoint}`
      }

      const connectUrl = `${protocol}://${host}:${port}${endpoint}`;
      this.connection.clientId = "user-" + this.user_detail.id + "-" + this.makeid(6);
      this.subscription.topic = "user-" + this.user_detail.id;
      // console.log('this.connection.clientId::', this.connection.clientId);

      try {
        this.client = mqtt.connect(connectUrl, options);
      } catch (error) {
        console.log("mqtt.connect error", error);
      }
      this.client.on("connect", () => {
        console.log("Connection succeeded!");
        this.doSubscribe();
      });
      this.client.on("error", (error) => {
        console.log("Connection failed", error);
      });
      this.client.on("message", (topic, message) => {
        let received_messages = "";
        let received_object = {};
        received_messages = received_messages.concat(message);
        received_object = JSON.parse(received_messages);

        const date_object = new Date();
        const current = date_object.getTime();
        const message_time = Date.parse(received_object.created_at);
        const times_ago = this.timeDifference(current, message_time);
        received_object.time_diffrence = times_ago;
        this.messages.unshift(received_object);
        this.notification_count = this.notification_count + 1;

        // console.log(`Received message ${message} from topic ${topic}`)
      });
    },
    doSubscribe() {
      const { topic, qos } = this.subscription;
      this.client.subscribe(topic, qos, (error, res) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        this.subscribeSuccess = true;
        // console.log('Subscribe to topics res', res)
      });
    },
    isExternalLink: function (to) {
      return typeof to === "string" && to.startsWith("http");
    },
    timeDifference: function (current, previous) {
      const msPerMinute = 60 * 1000;
      const msPerHour = msPerMinute * 60;
      const msPerDay = msPerHour * 24;
      const msPerMonth = msPerDay * 30;
      const msPerYear = msPerDay * 365;

      var elapsed = current - previous;

      /* if (elapsed < msPerMinute) {
        return Math.round(elapsed/1000) + ' seconds ago';
      } */

      if (elapsed < msPerHour) {
        return Math.round(elapsed / msPerMinute) + " minutes ago";
      } else if (elapsed < msPerDay) {
        return Math.round(elapsed / msPerHour) + " hours ago";
      } else if (elapsed < msPerMonth) {
        return "approximately " + Math.round(elapsed / msPerDay) + " days ago";
      } else if (elapsed < msPerYear) {
        return "approximately " + Math.round(elapsed / msPerMonth) + " months ago";
      } else {
        return "approximately " + Math.round(elapsed / msPerYear) + " years ago";
      }
    },
    makeid: function (length) {
      let result = "";
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    /* changeLang() {
      localStorage.setItem('app_lang', this.select_language)
      // this.$router.push({ path: this.$router.currentRoute.path }).catch(() => {})
      this.$router.go(this.$router.currentRoute)
    } */
    changeLang(lang) {
      localStorage.setItem("app_lang", lang);
      // this.$router.push({ path: this.$router.currentRoute.path }).catch(() => {})
      this.$router.go(this.$router.currentRoute);
    },
    fetchData() {
      if (!LocalStorage.get("userEmail")) {
        this.logout();
      }
      axios
        .post(
          process.env.VUE_APP_PROVISION_URL,
          {
            username: LocalStorage.get("userEmail"),
            password: LocalStorage.get("userPassword"),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.fetchedData = response.data.data.map((item) => ({
            value:
              item.accountId +
              "$" +
              item.deviceName +
              "$" +
              item.deviceType +
              "$" +
              item.baseAPIURL +
              "$" +
              item.isActive,
            label: item.deviceName,
          }));

          const accId = LocalStorage.get("accountId");
          const deviceName = LocalStorage.get("deviceName");
          const baseUrl = LocalStorage.get("baseAPIURL");
          const deviceType = LocalStorage.get("deviceType");
          const isActive = LocalStorage.get("isActive");

          const selItem =
            accId + "$" + deviceName + "$" + deviceType + "$" + baseUrl + "$" + isActive;

          const foundItem = this.fetchedData.find((item) => item.value === selItem);

          if (!foundItem) {
            this.LOGOUT();
            this.$router.push({ name: "Login" });
          }

          this.select_router = selItem;

          axios.defaults.baseURL = LocalStorage.get("baseAPIURL") + "/api";

          // const accI =  LocalStorage.get('accountId');
          // console.log(this.fetchedData);
        })
        .catch((error) => {
          // Handle error here
          console.error("Error fetching data:", error);
        });
    },
    handleRouterChange(routerSelVal) {
      const [
        accountId,
        deviceName,
        deviceType,
        baseAPIURL,
        isActive,
      ] = routerSelVal.split("$");

      if (isActive == 0) {
        Swal.fire({
          title: "Router Inactive",
          text:
            "To activate your router, please download the Audra App from playstore...",
          icon: "warning",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            const accId = LocalStorage.get("accountId");
            const devName = LocalStorage.get("deviceName");
            const baseUrl = LocalStorage.get("baseAPIURL");
            const devType = LocalStorage.get("deviceType");
            const isActv = LocalStorage.get("isActive");
            const selItem =
              accId + "$" + devName + "$" + devType + "$" + baseUrl + "$" + isActv;
            this.select_router = selItem;
          }
        });

        return;
      }

      LocalStorage.set("accountId", accountId);
      LocalStorage.set("deviceName", deviceName);
      LocalStorage.set("deviceType", deviceType);
      LocalStorage.set("baseAPIURL", baseAPIURL);
      LocalStorage.set("isActive", isActive);

      axios.defaults.baseURL = LocalStorage.get("baseAPIURL") + "/api";

      if (!this.user) {
        this.user = {};
      }

      this.user.username = LocalStorage.get("userEmail");
      this.user.password = LocalStorage.get("userPassword");

      this.LOGIN_AUDRA_DEVICE_SELECTION(this.user).then((response) => {
        // console.log('response from login component: ', response)
        // alert(response);
        // this.$router.push({ path: this.$router.currentRoute.path }).catch(() => {});
        // this.$router.go(this.$router.currentRoute);
        // this.$router.push({ path: "/admin" }).catch(() => {});

        if (this.$router.currentRoute.path === "/admin") {
          window.location.reload();
        } else {
          this.$router.push({ path: "/admin" }).catch(() => {});
          window.location.reload();
        }
      });
    },
  },
};
</script>
